import { Stack } from "@mui/material";
import {
  templateFiltersDefaultValue,
  useTemplateFilterFields,
} from "./TemplateFilterFields.js";

export { templateFiltersDefaultValue };

type NonPropertyFieldKey =
  | "templateTypeIds"
  | "categories"
  | "typeOfProjects"
  | "typeOfTemplates";

type Props = Omit<Parameters<typeof useTemplateFilterFields>[0], "viewType"> & {
  /** Drops a quick-filter field entirely, rather than merely disabling it. */
  excludeFields?: NonPropertyFieldKey[];
};

export const TemplateFilters = ({
  formikProps,
  excludeFields,
  ...props
}: Props) => {
  const { nonPropertyFields } = useTemplateFilterFields({
    ...props,
    formikProps,
    viewType: "buttons",
  });

  const visibleFields = excludeFields?.length
    ? nonPropertyFields.filter(
        field =>
          !excludeFields.some(excluded =>
            String(field.key).startsWith(excluded)
          )
      )
    : nonPropertyFields;

  return visibleFields.length > 0 ? (
    <Stack
      direction="row"
      spacing={1}
      useFlexGap
      sx={{
        flexWrap: "wrap",
        alignItems: "center",
        minHeight: "32px",
      }}
    >
      {visibleFields}
    </Stack>
  ) : null;
};
